<template>
  <table class="prepare-question__view" cellpadding="0" cellspacing="0" style="border:border: 1px solid #E5E5EA;margin: 0;width: 100%;">
    <tbody>
      <tr>
        <td style="padding: 40px 30px;">
          
          <table border="0" cellpadding="0" cellspacing="0" style="border: 0;margin: 0;width: 100%;">
            <tbody>
              <tr>
                <td style="vertical-align: top;width: 40%;">
                  <table border="0" cellpadding="0" cellspacing="0" style="border: 0;margin: 0;width: 100%;">
                    <tbody>
                      <tr>
                        <td style="text-align: center; padding-bottom: 10px;">
                          <span style="font-size: 26px; color: #40505e;font-weight: 600;line-height: 28px;">{{ examInfo.schoolName }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center;">
                          <span style="text-align: center;font-size: 17px; color: #40505e;font-weight: 600;">
                            Giáo viên: {{ examInfo.teacherName }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td style="width: 60%;">
                  <table border="0" cellpadding="0" cellspacing="0" style="border: 0;margin: 0;width: 100%;">
                    <tbody>
                      <tr>
                        <td style="text-align: center;padding-bottom: 10px;">
                          <span style="font-size: 26px; color: #40505e;font-weight: 600;line-height: 28px;">
                            Đề kiểm tra {{ renderTimeToDo() }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center;padding-bottom: 10px;">
                          <span style="font-size: 26px; color: #40505e;font-weight: 600;line-height: 28px;">
                            Môn: {{ renderSubjects() }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center;padding-bottom: 18px;">
                          <span style="font-size: 17px; color: #40505e;font-weight: 600;line-height: 20px;">
                            Thời gian làm bài: {{ renderTimeToDo() }}, không kể thời gian phát đề
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center;">
                          <span style="font-size: 17px; color: #40505e;font-weight: 600;line-height: 20px;">
                            Mã đề: {{ examInfo.code }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td style="text-align: center;padding: 45px 30px 30px 30px;" colspan="2">
                  <span
                    class="prepare-question__view__note font-sanpro-light font-italic font-size-18 primary-color-txt text-center full-width"
                    style="width: 100%;font-size: 18px; color: #40505e;font-weight: 300; font-style: italic;line-height: 20px;margin-bottom: 5px;text-align: center;"
                  >
                    {{ examInfo.note }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <table border="0" cellpadding="0" cellspacing="0" style="border: 0;margin: 0;width: 100%;">
            <tbody>
              <tr
                v-for="(item, index) of questionList"
                :key="index"
              >
                <td style="padding: 10px 0 25px;">
                  <table border="0" cellpadding="0" cellspacing="0" style="border: 0;margin: 0;width: 100%;">
                    <tbody>
                      <tr>
                        <td style="vertical-align: top;width: 60px; padding-bottom: 10px;text-align: left;">
                          <p>
                            <b
                              class="primary-color-txt"
                              style="font-weight: 700; color: #40505e; line-height: 24px;display: inline-block;"
                            >
                              {{ item.title }}
                            </b>
                            <span v-if="item.title" style="font-weight: 700; color: #40505e; line-height: 24px;">:</span>
                          </p>
                        </td>
                        <td style="vertical-align: top;padding-bottom: 10px;text-align: left;">
                          <span v-html="item.content" style="font-weight: 300; color: #40505e;"></span>
                        </td>
                      </tr>
                      <tr v-if="item.imageUrl">
                        <td colspan="2" style="text-align: center;padding-bottom: 25px;">
                          <img 
                            :src="item.isSample ? `${urlQuestionImg}/${item.imageUrl}` : `${appUrl}/${item.imageUrl}`"
                            alt="Ảnh câu trả lời"
                            style="max-width: 600px; height: auto;"
                          />
                        </td>
                      </tr>
                      <tr v-if="item.type !== questionDownAnswer">
                        <td colspan="2">
                          <table border="0" cellpadding="0" cellspacing="0" style="border: 0;margin: 0;width: 100%;">
                            <tbody>
                              <tr v-if="item.layoutId === 2">
                                <td
                                  v-for="(ans, pos) of item.answers"
                                  :key="pos"
                                  style="width: 25%;"
                                >
                                  <table border="0" cellpadding="0" cellspacing="0" style="border: 0;margin: 0;width: 100%;">
                                    <tbody>
                                      <tr v-if="ans.imageUrl">
                                        <td colspan="2" style="text-align: center;">
                                          <img 
                                            :src="item.isSample ? `${urlQuestionImg}/${ans.imageUrl}` : `${appUrl}/${ans.imageUrl}`" 
                                            alt="Ảnh câu trả lời"
                                            style="max-width: 100%; height: auto;"
                                          />
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style="vertical-align: top;text-align: center;width: 20px;">
                                          <p>
                                            <b style="font-weight: 600;font-size: 16px;color: #40505e;">{{ ans.code }}</b>
                                          </p>
                                        </td>
                                        <td style="vertical-align: top;text-align: left;width: calc(100% - 20px)">
                                          <span
                                            v-html="ans.content"
                                            style="font-size: 16px;font-weight: 300;color: #40505e;"
                                          ></span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <template v-else>
                                <tr
                                  v-for="(ans, pos) of item.answers"
                                  :key="pos"
                                >
                                  <td>
                                    <table border="0" cellpadding="0" cellspacing="0" style="border: 0;margin: 0;width: 100%;">
                                      <tbody>
                                        <tr v-if="ans.imageUrl">
                                          <td colspan="2" style="vertical-align: top;text-align: center;">
                                            <img 
                                              :src="item.isSample ? `${urlQuestionImg}/${ans.imageUrl}` : `${appUrl}/${ans.imageUrl}`" 
                                              alt="Ảnh câu trả lời"
                                              style="max-width: 100%; height: auto;"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="vertical-align: top;text-align: left;width: 20px;">
                                            <p>
                                              <b style="font-weight: 600;font-size: 16px;color: #40505e;">{{ ans.code }}</b>
                                            </p>
                                          </td>
                                          <td style="vertical-align: top;text-align: left;width: calc(100% - 20px)">
                                            <span
                                              v-html="ans.content"
                                              style="font-size: 16px; font-weight: 300;color: #40505e;"
                                            ></span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
  <!-- <div
    id="prepare_question_view"
    class="prepare-question__view"
    :class="{'width-100': nameRouter === 'examAdd'}"
    style="border: 1px solid #E5E5EA;"
    ref="avatar"
  >
    <div
      class="prepare-question__view__head"
      style="margin: 4% 0 35px;"
    >
      <div class="prepare-question__view__head__info" style="display: block; margin-bottom: 30px;">
        <div style="width: 35%;display:inline-block;margin-right: 3%;padding-left: 30px;">
          <div class="prepare-question__view__head__wrap">
            <p
              class="prepare-question__view__school font-sanpro-semibold font-size-26 primary-color-txt margin-0"
              style="text-align: center;font-size: 26px; color: #40505e;font-weight: 600;line-height: 28px;margin-bottom: 5px;"
            >
              {{ examInfo.schoolName }}
            </p>
            <p
              class="prepare-question__view__teacher font-sanpro-semibold font-size-18 primary-color-txt margin-0"
              style="text-align: center;font-size: 18px; color: #40505e;font-weight: 600;"
            >
              Giáo viên: {{ examInfo.teacherName }}
            </p>
          </div>
        </div>
        <div style="width: 61%; display: inline-block;padding-right: 20px;">
          <div class="prepare-question__view__head__wrap" style="text-align: center;">
            <p
              class="prepare-question__view__school font-sanpro-semibold font-size-26 primary-color-txt margin-0"
              style="font-size: 26px; color: #40505e;font-weight: 600;line-height: 28px;margin-bottom: 8px;"
            >
              Đề kiểm tra {{ renderTimeToDo() }}
            </p>
            <p
              class="prepare-question__view__subject font-sanpro-semibold font-size-26 primary-color-txt margin-0"
              style="font-size: 26px; color: #40505e;font-weight: 600;line-height: 28px;margin-bottom: 8px;"
            >
              Môn: {{ renderSubjects() }}
            </p>
            <p
              class="prepare-question__view__desc-time font-sanpro-semibold font-size-18 primary-color-txt margin-0"
              style="font-size: 18px; color: #40505e;font-weight: 600;line-height: 20px;margin-bottom: 10px;"
            >
              Thời gian làm bài: {{ renderTimeToDo() }}, không kể thời gian phát đề
            </p>
            <p
              class="prepare-question__view__desc-time font-sanpro-semibold font-size-18 primary-color-txt margin-0"
              style="font-size: 18px; color: #40505e;font-weight: 600;line-height: 20px;margin-bottom: 8px;"
            >
              Mã đề: {{ examInfo.code }}
            </p>
          </div>
        </div>
      </div>
      <p
        class="prepare-question__view__note font-sanpro-light font-italic font-size-18 primary-color-txt text-center full-width"
        style="width: 100%;font-size: 18px; color: #40505e;font-weight: 400;line-height: 20px;margin-bottom: 5px;text-align: center;padding: 0 30px;"
      >
        {{ examInfo.note }}
      </p>
    </div>
    <div
      class="prepare-question__view__body question-sample__list text-left"
      style="width: 100%;padding: 5px 30px; text-align: left;"
    >
      <div
        v-for="(item, index) of questionList"
        :key="index"
        class="item"
        :class="`item__${item.type} layout-${item.layoutId}`"
        style="margin-bottom: 25px;"
      >
        <div class="item__head" style="width: 100%; margin-bottom: 35px;">
          <b
            class="primary-color-txt"
            style="font-weight: 700; color: #40505e; line-height: 24px;"
          >
            {{ item.title }}
          </b>
          <span v-if="item.title" style="font-weight: 700; color: #40505e; line-height: 24px;">:</span>
          <div v-html="item.content" style="font-weight: 300; color: #40505e; line-height: 18px;margin-bottom: 20px;"></div>
          <div
            v-if="item.imageUrl"
            class="item__head__img text-center margin-center"
            style="max-width: 600px; margin: 0 auto;"
          >
            <img 
              :src="item.isSample ? `${urlQuestionImg}/${item.imageUrl}` : `${appUrl}/${item.imageUrl}`"
              alt="Ảnh câu trả lời"
              style="max-width: 100%; height: auto;"
            />
          </div>
        </div>
        <div class="item__body">
          <div v-if="item.type !== questionDownAnswer" class="answers" style="display: block;">
            <div
              v-for="(ans, pos) of item.answers"
              :key="pos"
              class="item__answer"
              style="margin-bottom: 15px; display: inline-block;"
              :style="item.layoutId === 2 ? `width: calc(100% / 4.4);margin-right: 10px;` : ''"
            >
              <div
                v-if="ans.imageUrl"
                class="item__answer__img text-center margin-center"
                style="max-width: 600px;margin-bottom: 8px;text-align: center;"
              >
                <img 
                  :src="item.isSample ? `${urlQuestionImg}/${ans.imageUrl}` : `${appUrl}/${ans.imageUrl}`" 
                  alt="Ảnh câu trả lời"
                  style="max-width: 100%; height: auto;"
                />
              </div>
              <div class="item__answer__content">
                <b style="font-weight: 600;font-size: 16px;">{{ ans.code }}</b>
                <div
                  class="item__answer__content__detail"
                  v-html="ans.content"
                  style="font-size: 16px;margin-left: 8px;"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STORE_KEY, BASE_64_DEFINE } from './../../_store/constants'
import { TYPE_RADIO, TYPE_DOWN_ANSWER } from '@/modules/question/preview-question/_store/constants'
import { APP_CONFIG } from '@/utils/constants'

// const imageToBase64 = require('image-to-base64')

export default {
  name: 'QuestionView',
  data () {
    return {
      questionDownAnswer: TYPE_DOWN_ANSWER,
      uploadUrl: APP_CONFIG.uploadUrl,
      appUrl: APP_CONFIG.appUrl,
      urlQuestionImg: APP_CONFIG.urlQuestionImg,
      cdnUrl: APP_CONFIG.cdnUrl,
      nameRouter: this.$route.name
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['examInfo', 'classesExam', 'subjectsExam', 'questionList', 'examTimesToDo'])
  },
  watch: {
    // questionList() {
    //   setTimeout(() => {
    //     this.convertImg2Base64()
    //   }, 1000)
    // }
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetListQuestions']),

    async convertImg2Base64 () {
      let self = this
      let imageElms = document.querySelectorAll('.prepare-question__view__body img')
      let lengthElms = imageElms.length
      if (lengthElms > 0) {
        for (let i = 0; i < lengthElms; i++) {
          let link = imageElms[i].src
          // link = await self.$html2canvas(imageElms[i], {type: 'dataURL'})
          // imageToBase64(link)
          //   .then(res => {
          //           console.log('Base 64: ', res)
          //       }
          //   ).catch(
          //       (error) => {
          //           console.log(error)
          //       }
          //   )
        }
      }
    },

    renderSubjects () {
      let indexSubjectCurr = this.subjectsExam.findIndex(sub => sub.subjectId === this.examInfo.subjectId)
      return indexSubjectCurr > -1 ? this.subjectsExam[indexSubjectCurr].name : ''
    },

    renderTimeToDo () {
      let indexTimeToDoCurr = this.examTimesToDo.findIndex(time => time.value === parseInt(this.examInfo.timeToDo))
      return indexTimeToDoCurr > -1 ? this.examTimesToDo[indexTimeToDoCurr].name : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.prepare-question__view{
  border: 1px solid #E5E5EA;
  // width: 80%;
  margin: 50px auto 0 auto;
  &__head{
    // margin-top: 4%;
  }
  &__body{
    // width: 80%;
    margin: 0 auto;
    .item__head, .item__answer__img{
      // max-width: 600px;
    }
  }
}
.width-100{
  width: 100% !important;
}

</style>